export const CardLoading = () => {
    return (
      <div className="space-y-6">
        {/* Header with title and filter loading */}
        <div className="flex justify-between flex-wrap gap-2.5">
          <div className="space-y-2">
            <div className="w-48 h-6 bg-gray-200 rounded animate-pulse" />
            <div className="w-64 h-4 bg-gray-200 rounded animate-pulse" />
          </div>
          <div className="w-40 h-10 bg-gray-200 rounded-lg animate-pulse" />
        </div>
  
        {/* Grid of loading cards */}
        <div className="grid 2xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[15px]">
          {Array.from({ length: 4 }).map((_, index) => (
            <div 
              key={index}
              className="bg-white rounded-[10px] border border-[#FFE3EF] overflow-hidden animate-pulse"
            >
              {/* Image placeholder */}
              <div className="relative w-full md:h-[229px] h-[200px] bg-gray-200 rounded-t-[10px] overflow-hidden">
                {/* Action buttons placeholder */}
                <div className="flex gap-2.5 absolute top-[19px] right-[19px]">
                  <div className="w-[35px] h-[35px] bg-gray-300 rounded-full" />
                  <div className="w-[35px] h-[35px] bg-gray-300 rounded-full" />
                </div>
              </div>
  
              {/* Content placeholder */}
              <div className="pt-5 md:px-[25px] px-3.5 pb-7 space-y-4">
                {/* Title */}
                <div className="w-3/4 h-6 bg-gray-200 rounded" />
                
                {/* Description */}
                <div className="space-y-2">
                  <div className="w-full h-3 bg-gray-200 rounded" />
                  <div className="w-4/5 h-3 bg-gray-200 rounded" />
                  <div className="w-3/4 h-3 bg-gray-200 rounded" />
                </div>
  
                {/* Rating and price */}
                <div className="grid sm:grid-cols-2 grid-cols-1 gap-3 items-center">
                  <div className="flex gap-1">
                    {Array.from({ length: 5 }).map((_, starIndex) => (
                      <div 
                        key={starIndex}
                        className="w-5 h-5 bg-gray-200 rounded"
                      />
                    ))}
                  </div>
                  <div className="w-full h-12 bg-gray-200 rounded-t-[20px] rounded-bl-[20px]" />
                </div>
  
                {/* Stats */}
                <div className="flex gap-[15px] pt-3 border-t border-[#FFE3EF] flex-wrap">
                  <div className="w-20 h-4 bg-gray-200 rounded" />
                  <div className="w-16 h-4 bg-gray-200 rounded" />
                  <div className="w-24 h-4 bg-gray-200 rounded" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  export const AdsSectionLoading = () => {
    return (<div className="slick-slider">
      <div className="slick-list">
        <div className="slick-track">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="slick-slide">
              <div className="border border-[#D9D9D9] rounded-[10px] animate-pulse">
                {/* Image Loading */}
                <div className="w-full h-[284.65px] bg-gray-200 rounded-t-[9px]"></div>
                
                {/* Content Loading */}
                <div className="pt-[14px] pb-[23px] pr-[17px] pl-[10px]">
                  {/* Title Loading */}
                  <div className="w-3/4 h-6 bg-gray-200 rounded mb-3"></div>
                  
                  {/* Address and Rating Loading */}
                  <div className="flex items-center gap-[10px] justify-between flex-wrap mb-3">
                    <div className="w-2/3 h-5 bg-gray-200 rounded"></div>
                    <div className="flex gap-1">
                      {Array.from({ length: 5 }).map((_, starIndex) => (
                        <div 
                          key={starIndex}
                          className="w-5 h-5 bg-gray-200 rounded"
                        ></div>
                      ))}
                    </div>
                  </div>
                  
                  {/* Hotel Icon and Text Loading */}
                  <div className="flex gap-[10px] items-center mt-[11px]">
                    <div className="w-6 h-6 bg-gray-200 rounded"></div>
                    <div className="w-48 h-4 bg-gray-200 rounded"></div>
                  </div>
                  
                  {/* Distance Loading */}
                  <div className="w-24 h-4 bg-gray-200 rounded mt-[10px]"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>)
  }

  export const CartLoading = () => {
    return (
      <div className="lg:py-[100px] md:py-[70px] sm:py-[50px] py-[30px]">
        <div className="container">
          <div className="grid xl:grid-cols-[669px_1fr] lg:grid-cols-2 grid-cols-1 lg:gap-[54px] gap-[20px]">
            
            {/* Left Side - Cart Items Loading */}
            <div className="w-full lg:max-w-[669px]">
              {/* Back Button Loading */}
              <div className="mb-4">
                <div className="w-32 h-6 bg-gray-200 rounded animate-pulse"></div>
              </div>
  
              {/* Steps Loading */}
              <div className="flex lg:gap-[74px] gap-[30px] items-center pb-[28px] border-b border-[#DDDDDD] mb-[28px]">
                {Array.from({ length: 3 }).map((_, index) => (
                  <div 
                    key={index}
                    className="w-24 h-6 bg-gray-200 rounded animate-pulse"
                  />
                ))}
              </div>
  
              {/* Cart Items Loading */}
              {Array.from({ length: 3 }).map((_, index) => (
                <div
                  key={index}
                  className="p-3 border border-[#DDDDDD] rounded-[10px] shadow-sm mb-[15px] grid md:grid-cols-[auto_1fr] grid-cols-1 gap-[20px] md:justify-between items-center animate-pulse"
                >
                  <div className="flex gap-[16px] items-center">
                    {/* Image Loading */}
                    <div className="md:w-[117.1px] md:h-[105px] w-[70px] h-[70px] rounded-[5px] bg-gray-200"></div>
                    
                    {/* Content Loading */}
                    <div className="space-y-2">
                      <div className="w-48 h-6 bg-gray-200 rounded"></div>
                      <div className="w-24 h-4 bg-gray-200 rounded"></div>
                    </div>
                  </div>
  
                  {/* Price and Quantity Loading */}
                  <div className="md:text-right text-center">
                    <div className="w-20 h-6 bg-gray-200 rounded mb-2 mx-auto md:mx-0"></div>
                    <div className="w-full md:max-w-[152px] ml-auto">
                      <div className="flex items-center justify-between border border-gray-300 rounded-full px-4 py-2 md:max-w-[152px]">
                        <div className="w-6 h-6 bg-gray-200 rounded-full"></div>
                        <div className="w-8 h-6 bg-gray-200 rounded"></div>
                        <div className="w-6 h-6 bg-gray-200 rounded-full"></div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
  
            {/* Right Side - Order Summary Loading */}
            <div className="w-full lg:max-w-[597px] h-max sticky top-[100px]">
              <div className="px-[25px] pt-[25px] pb-[33px] summary-box rounded-[10px] border border-[#DDDDDD]">
                
                {/* Title Loading */}
                <div className="w-40 h-7 bg-gray-200 rounded mx-auto mb-[30px] animate-pulse"></div>
  
                {/* Order Items Loading */}
                {Array.from({ length: 3 }).map((_, index) => (
                  <div key={index} className="flex justify-between items-center gap-[20px] mb-5">
                    <div className="w-32 h-6 bg-gray-200 rounded animate-pulse"></div>
                    <div className="w-16 h-6 bg-gray-200 rounded animate-pulse"></div>
                  </div>
                ))}
  
                {/* Token Fee Loading */}
                <div className="flex justify-between items-center gap-[20px] mb-5">
                  <div className="w-24 h-6 bg-gray-200 rounded animate-pulse"></div>
                  <div className="w-20 h-6 bg-gray-200 rounded animate-pulse"></div>
                </div>
  
                {/* Discount Loading */}
                <div className="flex justify-between items-center gap-[20px] mb-5">
                  <div className="w-20 h-6 bg-gray-200 rounded animate-pulse"></div>
                  <div className="w-28 h-6 bg-gray-200 rounded animate-pulse"></div>
                </div>
  
                {/* Total Before Taxes Loading */}
                <div className="flex justify-between items-center gap-[20px] pt-[19px] border-t border-[#DDDDDD] mt-[10px]">
                  <div className="w-40 h-7 bg-gray-200 rounded animate-pulse"></div>
                  <div className="w-20 h-7 bg-gray-200 rounded animate-pulse"></div>
                </div>
  
                {/* Apply Discount Button Loading */}
                <div className="w-32 h-6 bg-gray-200 rounded mt-4 animate-pulse"></div>
              </div>
  
              {/* Checkout Button Loading */}
              <div className="text-right">
                <div className="inline-block ml-auto rounded-[2px] bg-gray-200 w-40 h-16 animate-pulse md:mt-[35px] mt-[20px]"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  export const RestaurantDetailDetailedLoading = () => {
    return (
      <div className="lg:pb-[100px] md:pb-[70px] pb-[30px]">
        <div className="container">
          
          {/* Images Section with Skeleton */}
          <div className="grid grid-cols-1 lg:grid-cols-[605px_1fr] md:grid-cols-2 gap-[19px] mt-[36px] mb-[40px]">
            
            {/* Main Image Skeleton */}
            <div className="animate-pulse">
              <div className="rounded-tl-[10px] rounded-bl-[10px] w-full h-[400px] lg:h-full bg-gray-200 flex items-center justify-center">
                <div className="text-gray-400">Loading...</div>
              </div>
            </div>
  
            {/* Thumbnail Images Grid Skeleton */}
            <div className="grid grid-cols-2 gap-[20px] animate-pulse">
              {Array.from({ length: 4 }).map((_, index) => (
                <div 
                  key={index} 
                  className={`relative ${
                    index === 0 ? "rounded-tl-[10px]" : ""
                  } ${index === 1 ? "rounded-tr-[10px]" : ""} ${
                    index === 2 ? "rounded-bl-[10px]" : ""
                  } ${index === 3 ? "rounded-br-[10px]" : ""}`}
                >
                  <div className="w-full h-[190px] bg-gray-200 flex items-center justify-center">
                    <div className="text-gray-400 text-sm">Image {index + 1}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
  
          {/* Restaurant Header Info Skeleton */}
          <div className="grid grid-cols-1 lg:grid-cols-2 md:gap-[42px] mt-[30px] animate-pulse">
            
            {/* Text Info Skeleton */}
            <div className="space-y-4">
              {/* Restaurant Name Skeleton */}
              <div className="space-y-2">
                <div className="w-3/4 h-8 bg-gray-200 rounded"></div>
                <div className="w-1/2 h-6 bg-gray-200 rounded"></div>
              </div>
              
              {/* Address and Details Skeleton */}
              <div className="space-y-3">
                <div className="w-full h-5 bg-gray-200 rounded"></div>
                <div className="w-2/3 h-5 bg-gray-200 rounded"></div>
                <div className="flex gap-4 mt-3">
                  <div className="w-20 h-6 bg-gray-200 rounded"></div>
                  <div className="w-16 h-6 bg-gray-200 rounded"></div>
                  <div className="w-24 h-6 bg-gray-200 rounded"></div>
                </div>
              </div>
            </div>
  
            {/* Action Buttons Skeleton */}
            <div className="flex flex-col md:flex-row md:items-start md:justify-end gap-4 mt-6 lg:mt-0">
              <div className="flex gap-[10px]">
                {Array.from({ length: 3 }).map((_, index) => (
                  <div 
                    key={index}
                    className="flex flex-col items-center gap-2"
                  >
                    <div className="w-[36px] h-[36px] rounded-full border border-[#DDDDDD] bg-gray-200"></div>
                    <div className="w-12 h-3 bg-gray-200 rounded"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
  
          {/* Tabs Section Skeleton */}
          <div className="mt-8 animate-pulse">
            
            {/* Tab Headers Skeleton */}
            <div className="flex flex-wrap gap-2 md:gap-4 border-b border-[#DDDDDD] pb-3">
              {['Menu', 'Reviews', 'About', 'Book Table', 'Bookings', 'Orders'].map((tab, index) => (
                <div 
                  key={index}
                  className="px-4 py-2 rounded-lg bg-gray-200"
                >
                  <div className="w-16 h-5 bg-gray-300 rounded"></div>
                </div>
              ))}
            </div>
  
            {/* Tab Content Skeleton */}
            <div className="mt-6">
              <div className="w-full min-h-[400px] bg-gray-100 rounded-[10px] p-6">
                
                {/* Content Grid Skeleton */}
                <div className="grid md:grid-cols-2 gap-6">
                  
                  {/* Left Content Skeleton */}
                  <div className="space-y-4">
                    <div className="w-3/4 h-6 bg-gray-200 rounded"></div>
                    <div className="space-y-2">
                      <div className="w-full h-4 bg-gray-200 rounded"></div>
                      <div className="w-2/3 h-4 bg-gray-200 rounded"></div>
                      <div className="w-4/5 h-4 bg-gray-200 rounded"></div>
                    </div>
                    
                    {/* Features Skeleton */}
                    <div className="grid grid-cols-2 gap-3 mt-4">
                      {Array.from({ length: 4 }).map((_, index) => (
                        <div key={index} className="flex items-center gap-2">
                          <div className="w-4 h-4 bg-gray-200 rounded"></div>
                          <div className="w-20 h-4 bg-gray-200 rounded"></div>
                        </div>
                      ))}
                    </div>
                  </div>
  
                  {/* Right Content Skeleton */}
                  <div className="space-y-4">
                    <div className="w-1/2 h-6 bg-gray-200 rounded"></div>
                    <div className="space-y-3">
                      {Array.from({ length: 3 }).map((_, index) => (
                        <div key={index} className="flex justify-between">
                          <div className="w-24 h-5 bg-gray-200 rounded"></div>
                          <div className="w-16 h-5 bg-gray-200 rounded"></div>
                        </div>
                      ))}
                    </div>
                  </div>
  
                </div>
              </div>
            </div>
          </div>
  
        </div>
      </div>
    );
  };

  export const RestaurantGridLoading = () => {
    return (
      <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-[21px] w-full">
      {Array.from({ length: 6 }).map((_, index) => (
        <div 
          key={index}
          className="relative rounded-[10px] bg-white border border-[#D9D9D9] animate-pulse"
        >
          {/* Sponsored Badge Loading */}
          <div className="absolute top-2 left-2 w-20 h-6 bg-gray-200 rounded-full"></div>
          
          {/* Image Loading */}
          <div className="w-full h-[236px] bg-gray-200 rounded-t-[9px]"></div>
          
          {/* Content Loading */}
          <div className="pt-[14px] pb-[23px] pr-[17px] pl-[10px]">
            
            {/* Restaurant Name Loading */}
            <div className="w-3/4 h-6 bg-gray-200 rounded mb-3"></div>
            
            {/* Address and Rating Loading */}
            <div className="flex items-center gap-[10px] justify-between flex-wrap mb-3">
              <div className="w-2/3 h-5 bg-gray-200 rounded"></div>
              <div className="flex gap-1">
                {Array.from({ length: 5 }).map((_, starIndex) => (
                  <div 
                    key={starIndex}
                    className="w-5 h-5 bg-gray-200 rounded"
                  ></div>
                ))}
              </div>
            </div>
            
            {/* Hotel Icon and Text Loading */}
            <div className="flex gap-[10px] items-center mt-[11px]">
              <div className="w-6 h-6 bg-gray-200 rounded"></div>
              <div className="w-48 h-4 bg-gray-200 rounded"></div>
            </div>
            
            {/* Distance Loading */}
            <div className="w-24 h-4 bg-gray-200 rounded mt-[10px]"></div>
          </div>
        </div>
      ))}
    </div>
    );
  };

  export const HotelListingLoading = () => {
    return (
      <div className="lg:pb-[100px] md:pb-[70px] pb-[30px]">
        {/* Hotel Grid Loading */}
        <div className="grid grid-cols-1 lg:grid-cols-3 sm:grid-cols-2 gap-[21px] items-center animate-pulse">
          
          {/* Hotel Cards Loading */}
          {Array.from({ length: 6 }).map((_, index) => (
            <div 
              key={index}
              className="relative rounded-[10px] bg-white border border-[#D9D9D9]"
            >
              {/* Sponsored Badge Loading */}
              <div className="absolute top-2 left-2 w-20 h-6 bg-gray-200 rounded-full"></div>
              
              {/* Image Loading */}
              <div className="w-full h-[236px] bg-gray-200 rounded-t-[9px]"></div>
              
              {/* Content Loading */}
              <div className="pt-[14px] pb-[23px] pr-[17px] pl-[10px]">
                
                {/* Hotel Name Loading */}
                <div className="w-3/4 h-6 bg-gray-200 rounded mb-3"></div>
                
                {/* Address and Rating Loading */}
                <div className="flex items-center gap-[10px] justify-between flex-wrap mb-3">
                  <div className="w-2/3 h-5 bg-gray-200 rounded"></div>
                  <div className="flex gap-1">
                    {Array.from({ length: 5 }).map((_, starIndex) => (
                      <div 
                        key={starIndex}
                        className="w-5 h-5 bg-gray-200 rounded"
                      ></div>
                    ))}
                  </div>
                </div>
                
                {/* Hotel Icon and Rating Text Loading */}
                <div className="flex gap-[10px] items-center mt-[11px]">
                  <div className="w-6 h-6 bg-gray-200 rounded"></div>
                  <div className="w-48 h-4 bg-gray-200 rounded"></div>
                </div>
                
                {/* Distance Loading */}
                <div className="w-24 h-4 bg-gray-200 rounded mt-[10px]"></div>
              </div>
            </div>
          ))}
        </div>
  
        {/* Pagination Loading */}
        <div className="flex justify-center items-center gap-2 mt-8 animate-pulse">
          {Array.from({ length: 5 }).map((_, index) => (
            <div 
              key={index}
              className="w-10 h-10 bg-gray-200 rounded"
            ></div>
          ))}
        </div>
      </div>
    );
  };